
import { Vue, Component } from 'vue-property-decorator'
import AreaOrderReport from '@/views/dataReport/template/AreaOrderReport.vue'
import AreaGoodsReport from '@/views/dataReport/template/AreaGoodsReport.vue'
import { Debounce } from '@/core/decorator'
@Component({
  name: 'AreaReport',
  components: { AreaOrderReport ,AreaGoodsReport}
})
export default class AreaReport extends Vue {
  checkType='1' //1:按订单查看  2:按商品查看

  $refs!: {
    areaGoodsReport: AreaGoodsReport,
    areaOrderReport: AreaOrderReport,
  }

  @Debounce(500)
  handleExport(){
    switch (this.checkType){
      case '1':
        this.$refs.areaOrderReport.handleExport()
        break;
      case '2':
        this.$refs.areaGoodsReport.handleExport()
        break;
    }
  }
}
